import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
  name: "auth",

  initialState: {
    token: null,
  },
  reducers: {
    storeToken: (state, action) => {
      state.token = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { storeToken } = authSlice.actions;

export default authSlice.reducer;
